/** import external dependencies */
import 'jquery';
import 'bootstrap';
import 'imports?jQuery=jquery!owl.carousel';
import 'imports?jQuery=jquery!jquery.scrollto';
import 'imports?jQuery=jquery!@fancyapps/fancybox';

/** import local dependencies */
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleProduct from './routes/singleproduct';
import woocommerceCheckout from './routes/woocommercecheckout';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  /** All pages */
  common,
  /** Home page */
  home,
  /** About Us page, note the change from about-us to aboutUs. */
  aboutUs,

  singleProduct,

  woocommerceCheckout,
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js